module.exports = __webpack_public_path__ + "static/media/product-4.d9ed7537.png";